import { Component } from '@theme/component';

class WishlistIcon extends Component {
  requiredRefs = ['wishlistCounter'];

  get #counter() {
    return /** @type {HTMLElement} */ (this.refs.wishlistCounter);
  }

  get currentWishlistCount() {
    return parseInt(this.#counter.textContent ?? '0', 10);
  }

  set currentWishlistCount(value) {
    this.#counter.textContent = value > 0 ? String(value) : '';
    if (value > 0) {
      this.#counter.classList.add('has-count');
    } else {
      this.#counter.classList.remove('has-count');
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.initGrowave();
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    if (this.growaveSdkReadyListener) {
      document.removeEventListener('gwSdkReady', this.growaveSdkReadyListener);
    }
    if (window.gw && window.gw.sdk && typeof window.gw.sdk.off === 'function') {
      if (this.growaveAddedListener) {
        window.gw.sdk.off(
          window.gw.sdk.wishlists.events.WISHLIST_ITEM_CREATED,
          this.growaveAddedListener
        );
      }
      if (this.growaveRemovedListener) {
        window.gw.sdk.off(
          window.gw.sdk.wishlists.events.WISHLIST_ITEM_DELETED,
          this.growaveRemovedListener
        );
      }
    }
  }

  initGrowave = () => {
    const setup = () => {
      const gw = window.gw;
      if (!gw) return;

      const moduleName = gw.sdk.common.constants.modules.WISHLISTS;
      gw.sdk.runIfModuleReady(moduleName, () => {
        const { WISHLIST_ITEM_CREATED, WISHLIST_ITEM_DELETED } =
          gw.sdk.wishlists.events;

        this.growaveAddedListener = () => this.updateWishlistCounter();
        this.growaveRemovedListener = () => this.updateWishlistCounter();

        gw.sdk.on(WISHLIST_ITEM_CREATED, this.growaveAddedListener);
        gw.sdk.on(WISHLIST_ITEM_DELETED, this.growaveRemovedListener);

        this.updateWishlistCounter();
      });
    };

    if (window.gw && window.gw.sdk) {
      setup();
    } else {
      this.growaveSdkReadyListener = setup;
      document.addEventListener('gwSdkReady', this.growaveSdkReadyListener);
    }
  };

  updateWishlistCounter = () => {
    if (!this.refs.wishlistCounter) return;

    window.gw?.sdk.wishlists.methods
      .getWishlistItems()
      .then((response) => {
        this.currentWishlistCount = /** @type {any} */ (response)?.result?.length ?? 0;
      })
      .catch(() => {});
  };
}

if (!customElements.get('wishlist-icon')) {
  customElements.define('wishlist-icon', WishlistIcon);
}
